import { Info } from "@emotion-icons/material/Info";
import Section from "../Section";
import { H3 } from "../Headers/Headings";
import styles from "./InfoMessageBox.module.css";

export const InfoMessageBox = ({ title, body, testId }: { title?: string; body: string; testId?: string }) => (
  <Section>
    <div className={styles.wrapper} data-testid={testId}>
      <Info size='1.5rem' />
      <div className={styles.content}>
        {title && <H3 variant='noTop'>{title}</H3>}
        <p className={styles.body}>{body}</p>
      </div>
    </div>
  </Section>
);
